<template>
  <BaseNotification
    type="warning"
    layout="inline"
  >
    <div class="mt-px">
      This does not seem to be a valid email address. Please check if your email address is correct.
    </div>
  </BaseNotification>
</template>

<script>
import BaseNotification from '../Ui/BaseNotification.vue';

export default {
  name: 'InvalidEmailWarning',
  components: { BaseNotification },
};
</script>

<style lang="scss" scoped>

</style>
